<template>
  <div class="fee-schedule bg--color-02">
    <div class="container-new pt-26 pt-60--l pb-32">
      <div class="fee-schedule__top-block flx flx--col">
        <h3
          class="txt--bold txt--color-04 txt--26px txt--52px--l txt--height-34px txt--height-64px--l"
        >
          {{ $t('feeSchedule.title') }}
        </h3>
        <div
          class="fee-schedule__description flx flx--col bg--color-01 sha--03 bor--radius-12 p-16"
        >
          <div class="fee-schedule__info flx flx--col">
            <span
              class="txt--bold txt--color-04 txt--26px txt--height-34px mb-16"
            >
              {{ $t('feeSchedule.desc.title') }}
            </span>
            <p class="txt--color-03 txt--16px txt--height-20px mb-0">
              <span
                v-for="(text, i) in $t('feeSchedule.desc.descText')"
                :key="i"
              >
                <nuxt-link
                  v-if="i === 1"
                  :to="localePath('/user/verification')"
                  class="txt--red"
                >
                  {{ text }}
                </nuxt-link>
                <span v-else>
                  {{ text }}
                </span>
              </span>
            </p>
          </div>
          <ul class="fee-schedule__points flx flx--col">
            <li
              v-for="(point, indx) in $t('feeSchedule.desc.points')"
              :key="indx"
              class="fee-schedule__point flx flx--items-center"
            >
              <div
                class="fee-schedule__point-number flx flx--center bg--color-10"
              >
                <span class="txt--color-04 txt--12px txt--height-14px">
                  0{{ indx + 1 }}.
                </span>
              </div>
              <div class="ml-12">
                <span
                  class="fee-schedule__point-title txt--bold txt--color-04 txt--14px txt--height-18px"
                >
                  {{ point.title }}
                </span>
                <p
                  class="fee-schedule__point-desc txt--weight-500 txt--color-03 txt--12px txt--height-14px mb-0"
                >
                  {{ point.desc }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <fee-schedule-table class="mt-26 mt-32--l" />
    </div>
  </div>
</template>

<script>
import defaultHeadMeta from '@/mixins/defaultHeadMeta'

export default {
  name: 'FeeSchedule',
  components: {
    FeeScheduleTable: () =>
      import(
        /* webpackChunkName: "InfoPagesComponents" */ '@/components/fee-schedule/FeeScheduleTable.vue'
      ),
  },
  mixins: [defaultHeadMeta],
  computed: {},
}
</script>

<style lang="scss" scoped>
.fee-schedule {
  display: flex;
  flex-direction: column;
  flex: 1;

  &__top-block {
    gap: toRem(26px);

    @include bp(l) {
      flex-direction: row;
      gap: toRem(50px);
      justify-content: space-between;
    }
  }

  &__description {
    gap: toRem(16px);

    @include bp(l) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: toRem(40px);
    }
  }

  &__info {
    @include bp(l) {
      max-width: toRem(314px);
    }
  }

  &__points {
    list-style-type: none;
    gap: toRem(16px);
  }

  &__point-number {
    width: 100%;
    max-width: toRem(32px);
    height: toRem(32px);
    border-radius: 100px;
  }
}
</style>
